import React from "react";

export default function DayBookIcon() {
  return (
    <svg
                    width="24"
                    height="24"
                    x="0"
                    y="0"
                    viewBox="0 0 466.415 466.415"
                    className=""
                  >
                    <g>
                      <path
                        d="M464.8 309.008c-3.1-4.6-9.2-5.8-13.8-2.7l-74.6 48.9h-98.2v-41h101.2c2.1 0 4.2-.8 5.8-2l77-55.6c4.5-3.2 5.5-9.5 2.2-13.9-3.2-4.5-9.5-5.5-13.9-2.2l-74.3 53.7h-98v-42h101.2c2.2.1 4.4-.6 6.2-1.9l77-60.7c4.3-3.5 5-9.8 1.6-14.1s-9.6-5-14-1.7l-74.3 58.4h-97.7v-40h101.2c2.5-.1 5-1.1 6.8-2.8l77-71.4c3-2.9 4-7.3 2.5-11.2-1.5-3.9-5.2-6.5-9.3-6.6H361c-.1 0-.3-1.8-.6-2.6-1.5-3.8-5.2-6.4-9.3-6.4h-153c-2.5 0-5 1-6.8 2.7l-6.7 6.3H87c-2.5.1-5 1.1-6.8 2.9l-77 71.3c-3 2.9-4 7.3-2.5 11.2 1.5 3.9 5.2 6.5 9.3 6.6h95.2v40H10c-5.5 0-10 4.5-10 10s4.5 10 10 10h95.2v42H10c-5.5 0-10 4.5-10 10s4.5 10 10 10h95.2v41H10c-5.5 0-10 4.5-10 10s4.5 10 10 10h369.4c2-.1 3.9-.7 5.5-1.9l77-50.4c4.6-3 5.9-9.3 2.9-13.9zm-118.9-188.8h85l-55.4 52h-85.1l55.1-51.6c.1 0 .2-.4.4-.4zm-237.9 52H35.5l55.4-52h72.2l-54.6 51.2c-.2.1-.3-.2-.5.8zm150.2 6.5v176.5h-133v-172.1l68.5-63.9 8.3-8h123.7l-64.3 59.9c-2.1 2-3.2 4.7-3.2 7.6z"
                        fill="#000000"
                        opacity="1"
                        data-original="#000000"
                        className=""
                      ></path>
                      <path
                        d="M233.8 231.308h-13.5c-1.1-5-3.1-9.7-5.8-14h19.3c5.6-.1 10.1-4.6 10.1-10.1s-4.5-10-10-10h-78.4c-5.5 0-10 4.5-10 10s4.5 10 10 10H178c9.5 0 17.6 5 21.4 14h-43.9c-5.5 0-10 4.5-10 10s4.5 10 10 10h43.9c-1.3 2.3-2.9 4.5-4.7 6.4-4.5 4.4-10.5 6.7-16.8 6.6h-22.5c-5.6.1-10.1 4.6-10 10.2 0 2.7 1.2 5.3 3.1 7.2l56.1 53.1c4 3.8 10.3 3.7 14.1-.3 3.8-4 3.7-10.3-.3-14.1l-.1-.1-37.9-35.8c10.6-.5 20.7-5 28.3-12.5 5.6-5.8 9.6-12.9 11.6-20.6h13.5c5.5 0 10-4.5 10-10s-4.5-10-10-10z"
                        fill="#000000"
                        opacity="1"
                        data-original="#000000"
                        className=""
                      ></path>
                    </g>
                  </svg>
  );
}
